import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createLocalEstoqueCadastro, updateLocalEstoqueCadastro } from '../service';
import {
  CREATE_LOCAL_ESTOQUE_CADASTRO,
  CREATE_LOCAL_ESTOQUE_CADASTRO_PENDING,
  CREATE_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
  CREATE_LOCAL_ESTOQUE_CADASTRO_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateLocalEstoqueCadastro(action) {
  yield put({ type: CREATE_LOCAL_ESTOQUE_CADASTRO_PENDING });

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createLocalEstoqueCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.LOCAL_ESTOQUE_CRIAR);
    } else {
      yield call(updateLocalEstoqueCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.LOCAL_ESTOQUE_EDITAR);
    }

    yield put({ type: CREATE_LOCAL_ESTOQUE_CADASTRO_SUCCESS, registro: action.data });

    if(!action.isCadastroRapido){
      history.push('/estoque/localEstoqueCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_LOCAL_ESTOQUE_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateLocalEstoqueCadastro() {
  yield takeLatest(CREATE_LOCAL_ESTOQUE_CADASTRO, sagaCreateLocalEstoqueCadastro);
}
